import { makeAutoObservable } from 'mobx';

export interface AppointerArgs {
	id: number;
	name: string;
}

export class Appointer {
	private _id: number;
	private _name: string;

	constructor(args: AppointerArgs) {
		makeAutoObservable(this);

		this._id = args.id;
		this._name = args.name;
	}

	// getters

	get id() {
		return this._id;
	}
	get name() {
		return this._name;
	}

	// getters end
}
